import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";


// components
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {
    info,
    LIST,
    NO_DATA_FOUND,
    success,
    TOAST_SYNC_SINGLE_PRODUCT_NO_PROMO_PRICES, updateMsg, error
} from "../../../components/i18n/i18n";

// actions
import {setFilter, setForm, setItem, setLoading, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services

// utils
import {getStateByPath} from "../../../redux/selectors";
import {GenericButton} from "../../../components/buttons/customButtons";
import {productService} from "../../../jwt/_services/promotions/productService";
import ProductPriceElement from "../../../components/promotion/productPriceElement";
import ProductFilters from "./_filters";
import {showToastCustom} from "../../../components/toast/customToast";
import {productPriceService} from "../../../jwt/_services/promotions/productPriceService";
import {GenericConfirmAlert} from "../../../components/confirmAlert/GenericConfirmAlert";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import ProductForm from "./_form";

const ProductList = (props) => {
    const path = props?.path ;
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    useEffect( () => {
        if( !app.id || filter  )
            return

        props.setFilter(path, {
            onlyRegistered: true,
            fbDataBase : { id : app?.fbDataBase?.id },
            item :  {
            }
        })
    }, [ app ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, productService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(ProductForm, { path })
    }

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(ProductForm, { path, data, closeOnEscape:false,  closeOnClickOutside: false})
    }

    const handleStatusChange = async (id, data, _status) => {
        genericIndexedActions.update(path, productService, id, {
            fbDataBase: {id: app?.fbDataBase?.id},
            item: {...data, status: _status, id: id}
        })
    }

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: productService,
        remove : genericIndexedActions.delete,
    } );

    const syncSingleProductPrices = data => {
        showToastCustom(info, TOAST_SYNC_SINGLE_PRODUCT_NO_PROMO_PRICES);
        props.setLoading(path, true);
        productPriceService.syncSingleProductPrices(data)
            .then(_ => {
                showToastCustom(success, updateMsg, true);
                props.setLoading(path, false);
                genericIndexedActions.search(path, productService, pageIndex, pageSize, filter)
            })
            .catch(errorMessage => {
                props.setLoading(path, false);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmSyncNoPromoPrices = (dataRequest) => {
        return GenericConfirmAlert({
            dataRequest,
            method: syncNoPromoPrices}
        );
    };

    function syncNoPromoPrices (dataRequest) {
        showToastCustom(info, 'Sync Regular Prices', true);

        props.setLoading(path, true);
        productPriceService.syncNoPromoPrices()
            .then(_ => {
                showToastCustom(success, updateMsg, true);
                console.log('Correct regular prices sync')
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
            })
            .finally(
                props.setLoading(path, false)
            )
    }

    const confirmSyncData = dataRequest => {
        return GenericConfirmAlert( {
            dataRequest,
            method: syncData
        });
    };

    function syncData(dataRequest) {
        showToastCustom(info, 'Sync Data', true);

        props.setLoading(path, true);
        productService.syncFirebase(dataRequest)
            .then(_ => {
                showToastCustom(success, updateMsg, true);
                console.log('Correct No Promo Sync')
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
            })
            .finally(
                props.setLoading(path, false)
            )
    }

    const expandRow = {
        renderer: row => (
            <ProductPriceElement row={row}/>
        ) ,
        showExpandColumn : true,
        expandByColumnOnly: true,
    };

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        headerStyle: {width: '200px'},
        text: 'uid'
    }, {
        dataField: 'description',
        text: 'Nombre'
    }, {
        dataField: 'sivexId',
        text: 'Id Sivex',
        headerStyle: {width: '100px'},
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'sivexCode',
        text: 'Codigo Sivex',
        headerStyle: {width: '100px'},
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: (cell, row) => <GenericSwitch
            id={ row?.id }
            initialState={ row?.status }
            onChange={ handleStatusChange }
        />
    }, {
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '200px'},
        formatter: (cell, row) => <>
            <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
            <GenericButton style={'table'} toolTip={'Actualizar precios'} icon={'fa-dollar'} permission={'prices'} onClick={() => syncSingleProductPrices(row)}/>
            <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
        </>
    }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'warning-secondary'}
                    label={'Precios'}
                    toolTip={'Actualiza los precios de los productos regulares'}
                    icon={'fa-dollar'}
                    permission={'prices'}
                    onClick={() => confirmSyncNoPromoPrices({})}
                />
                <GenericButton
                    style={'warning-secondary'}
                    label={'Sincronizar'}
                    toolTip={'Actualiza todos los productos hacia firebase'}
                    icon={'fa-sync'}
                    permission={'prices'}
                    onClick={() => confirmSyncData({
                        onlyRegistered: true,
                        fbDataBase: { id: app?.fbDataBase?.id },
                    })}
                />
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <ProductFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                expandRow={ expandRow }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = _ => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setItem,
    setForm,
    setLoading,
})

export default connect(mapStateToProps, mapActionsToProps)(ProductList);